import { z } from 'zod'

const airportSchema = z.object({
  city: z.string()
})

/** 區域物件 Schema */
const areaSchema = z.object({
  area: z.string(),
  airports: z.record(z.string(), airportSchema)
})

const departureSchema = z.record(z.string(), areaSchema)

const cityPairSchema = z.record(z.string(), z.record(z.string(), areaSchema))

const cabinSchema = z.object({
  ED: z.array(
    z.object({
      code: z.string(),
      status: z.string()
    })
  )
})

export const evaCityPairSchema = z.object({
  departure: departureSchema,
  citypair: cityPairSchema,
  cabin: cabinSchema
})

export interface EvaCityPair extends z.infer<typeof evaCityPairSchema> {}
